<template>
  <div>
    <template v-if="showDate == true">
      <template v-if="_.isEmpty(list) && !pageLoading">
        <div class="empty">
          <div class="empty-img">
            <i class="icon icon-opt-no" />
          </div>
          <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
        </div>
      </template>
      <template v-else>
        <div class="breakdown">
          <strong :class="totalCss" v-if="showTotalLineCnt == true">
            {{ /*총 건수*/ $t("MCOM-0000079") }} : {{ totalLineCnt }}
            <span class="standard-date">
              <slot name="term"></slot>
            </span>
          </strong>
          <template v-if="tagType == 'ul'">
            <ul class="breakdown-list">
              <template>
                <li v-for="(data, i) in dataGrid" :key="i">
                  <div class="divider" v-if="i != 0">
                    <span class="divider-date">{{ $getGlobalDateFmt(data[classifyDateField]) }}</span>
                  </div>
                  <ul v-for="(output, i) in data.outItem" :key="i">
                    <li>
                      <slot name="list" :row="output"></slot>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
            <slot name="search-list-bottom" v-if="showBottom"></slot>
          </template>
          <template v-if="showSearchBar">
            <search-range v-if="showSearch" :defaultRangeIndex="defaultRangeIndex" :defaultRangeList="rangeList" />
          </template>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="_.isEmpty(dataGrid)">
        <div class="empty">
          <div class="empty-img">
            <i class="icon icon-opt-no" />
          </div>
          <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
        </div>
      </template>
      <template v-else>
        <div class="breakdown">
          <strong :class="totalCss" v-if="showTotalLineCnt == true">
            {{ /*총 건수*/ $t("MCOM-0000079") }} : {{ totalLineCnt }}
            <span class="standard-date">
              <slot name="term"></slot>
            </span>
          </strong>
          <template v-if="tagType == 'ul'">
            <ul class="breakdown-list">
              <template>
                <li v-for="(data, i) in dataGrid" :key="i">
                  <ul>
                    <li :class="pageType == 'autoTrsacc' || pageType == 'transfer' ? 'list-item' : ''">
                      <slot name="list" :row="data" :rowIdx="i"></slot>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
            <slot name="search-list-bottom" v-if="showBottom"></slot>
          </template>
          <template v-else-if="tagType == 'div'">
            <div :class="cssClass" v-for="(data, i) in dataGrid" :key="i">
              <slot name="list" :row="data" :rowIdx="i"></slot>
            </div>
            <slot name="search-list-bottom" v-if="showBottom"></slot>
          </template>
          <template v-if="showSearchBar">
            <search-range v-if="showSearch" :defaultRangeIndex="defaultRangeIndex" :defaultRangeList="rangeList" />
          </template>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import SearchRange from "@/components/page/common/SearchRange";
import Common from "@/components/basic/Common";
export default {
  name: "CommonGrid",
  extends: Common,
  components: {
    SearchRange,
  },
  props: {
    //outItem.dataGrid
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    rangeList: {
      type: Array,
      required: false,
      default: () => [
        { text: "1M", value: -1 },
        { text: "3M", value: -3 },
        { text: "6M", value: -6 },
        { text: "MPAY-04-01-03-11", value: "" },
      ],
    },
    //반복태그 type
    tagType: {
      type: String,
      default: "ul",
    },
    cssClass: {
      type: Array,
      default: () => [],
    },
    //총 건수 노출 여부
    showTotalLineCnt: {
      type: Boolean,
      default: true,
    },
    //총 건수
    totalLineCnt: {
      type: Number,
      default: 0,
    },
    //날짜 구분 여부
    showDate: {
      type: Boolean,
      default: false,
    },
    //날짜 구분 필드명
    classifyDateField: {
      type: String,
      default: null,
    },
    showSearchBar: {
      type: Boolean,
      default: false,
    },
    //마지막 스크롤 이벤트 발생 여부
    scrollEvent: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: null,
    },
    showBottom: {
      type: Boolean,
      default: false,
    },
    totalCss: {
      type: Array,
      default: () => ["total-count"],
    },
    defaultRangeIndex: {
      type: Number,
    },
  },
  data() {
    return {
      dataGrid: [],
      scrollPostion: 0,
      showSearch: false,
    };
  },
  created() {
    if (this.scrollEvent) window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    if (this.scrollEvent) window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {},
  methods: {
    classifyDate(page, showSearchRange) {
      this.showSearch = showSearchRange;
      let tempData = [];
      let tempDate = "";
      let field = this.classifyDateField;
      let i = 0;

      for (const key of this.list) {
        let splitDateObject = {};
        if (tempDate != key[field]) {
          splitDateObject = {
            outItem: [key],
            [field]: key[field],
          };
          tempDate = key[field];
          tempData.push(splitDateObject);
          i++;
        } else {
          tempData[i - 1].outItem.push(key);
        }
      }

      if (page == 1) {
        this.dataGrid = tempData;
      } else {
        if (this.dataGrid[this.dataGrid.length - 1][field] == tempData[0][field]) {
          this.dataGrid[this.dataGrid.length - 1].outItem = [...this.dataGrid[this.dataGrid.length - 1].outItem, ...tempData[0].outItem];
          tempData.splice(0, 1);
          this.dataGrid = [...this.dataGrid, ...tempData];
        } else {
          this.dataGrid = [...this.dataGrid, ...tempData];
        }
      }
    },
    changeList(listData) {
      this.dataGrid = listData;
      if (this.showSearchBar == true) {
        if (this.dataGrid.length < this.totalLineCnt) {
          this.showSearch = false;
        } else {
          this.showSearch = true;
        }
      }
    },
    handleScroll() {
      let scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      let scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      let clientHeight = document.documentElement.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 30) {
        if (this.showSearch == false && this.scrollEvent && this.totalLineCnt != 0) {
          this.$emit("reSearch");
        }
      }
    },
  },
};
</script>
